import { expandBaseWebBorder, expandBorderRadii } from "@gadgetinc/widgets";
import { useStyletron } from "baseui";
import { Card, StyledBody } from "baseui/card";
import { HeadingLevel } from "baseui/heading";
import { ParagraphMedium } from "baseui/typography";
import React from "react";
import { useHover } from "web/src/lib/hooks";
import { DocLink } from "./DocLink";

export const HomeCard = (props: { title: string; time: string; body: string; link: string; topics: string[] }) => {
  const [css, $theme] = useStyletron();
  const [isHovered, hoverProps] = useHover();

  return (
    <DocLink href={props.link || "#"} $style={{ textDecoration: "none", flex: "1", paddingBottom: "12px" }} {...hoverProps}>
      <Card
        overrides={{
          Root: {
            style: {
              backgroundColor: isHovered ? $theme.colors.primary50 : $theme.colors.background,
              margin: "0.5rem 0",
              minWidth: "100%",
              ...expandBaseWebBorder({
                borderStyle: "solid",
                borderColor: isHovered ? $theme.colors.borderAlt : $theme.colors.border,
                borderWidth: "1.5px",
              }),
              ...expandBorderRadii($theme.borders.radius200),
            },
          },
        }}
      >
        <StyledBody>
          <HeadingLevel>
            <div className={css({ display: "flex", justifyContent: "space-between", alignItems: "baseline" })}>
              <div className={css({ marginBottom: $theme.sizing.scale200 })}>
                <span
                  className={css({
                    ...$theme.typography.HeadingSmall,
                    color: $theme.colors.contentPrimary,
                  })}
                >
                  {props.title}
                </span>
                <div
                  className={css({
                    ...$theme.typography.ParagraphSmall,
                    color: $theme.colors.contentSecondary,
                  })}
                >
                  {props.topics && <span>{props.topics.map((topic, i) => (i < props.topics.length - 1 ? `${topic}, ` : topic))}</span>}
                </div>
              </div>
            </div>
          </HeadingLevel>
          <ParagraphMedium>{props.body}</ParagraphMedium>
        </StyledBody>
      </Card>
    </DocLink>
  );
};
